import { useQuery } from '@tanstack/react-query'
import { RegisteredBabysittersRequestParams } from '../types/APIRequestType'
import cacheKeys from '../cacheKeys'
import { registeredBabysitters } from '../index'

const useGetRegisteredBabySitter = (
  queryParams: RegisteredBabysittersRequestParams,
) => {
  return useQuery({
    queryKey: [cacheKeys.REGISTERED_BABYSITTERS, queryParams],
    queryFn: registeredBabysitters,
  })
}

export default useGetRegisteredBabySitter
